import logApi from '../api/logApi';
import { IApiResponse } from '../interfaces/IApiResponse';
import WebIMConfig from '../libs/webIMConfig';

interface LogData {
  type: string;
  category: string;
  message: string;
  stackTrace?: string;
}

class LogService {
  addLog(data: LogData): Promise<IApiResponse> {
    try {
      let { stackTrace } = data;
      const { type, category, message } = data;
      stackTrace = (stackTrace && stackTrace.substr(0, 65000)) || 'null';
      // console.log("logData", data);
      return WebIMConfig.isConnected
        ? logApi
            .addLog({ type, category, message, stackTrace })
            .then(res => {
              //  console.log(res)
              // if (typeof cb === "function") {
              //   cb();
              // }
              return { success: true };
            })
            .catch(ex => {
              // if (typeof cb === "function") {
              //   cb();
              // }
              return { success: false };
            })
        : Promise.resolve({ success: false });
    } catch (error) {
      console.log('logService', error);
    }
    return Promise.resolve({ success: false });
  }
}

export default new LogService();
